import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import styled from 'styled-components';

import Img from 'gatsby-image';

const Thumbnail = styled(Img)`
  border-radius: 6px;
  height: auto;
  min-height: 15.3125rem;
  max-height: 20.75rem;
  width: 100%;

  margin-bottom: 0.875rem;

  @media (min-width: 555px) {
    margin-bottom: '0px';
  }
`;

const Wrapper = styled(Link)`
  display: flex;
  flex-direction: column;

  @media (min-width: 555px) {
    flex-direction: row;

    section {
      flex: 35rem;
      padding-left: 1.125rem;
    }
  }
  @media (min-width: 990px) {
    section {
      flex: 40rem;
      padding-left: 2.125rem;
    }
  }
`;

function PostCardHighlight({
  title, featuredImage, excerpt, slug
}) {
  return (
    <article>
      <Wrapper to={slug}>
        {featuredImage && (
          <Thumbnail
            fluid={featuredImage.fluid}
            alt={featuredImage.description}
            objectFit="cover"
            objectPosition="50% 50%"
          />
        )}
        <section>
          <h3>{title}</h3>
          <p>{excerpt}</p>
        </section>
      </Wrapper>
    </article>
  );
}

PostCardHighlight.defaultProps = {
  excerpt: '...',
  featuredImage: {},
};

PostCardHighlight.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  excerpt: PropTypes.string,
  featuredImage: PropTypes.shape({
    fluid: PropTypes.shape({
      aspectRatio: PropTypes.number,
      base64: PropTypes.string,
      sizes: PropTypes.string,
      src: PropTypes.string,
      srcSet: PropTypes.string,
      srcSetWebp: PropTypes.string,
      srcWebp: PropTypes.string,
    }),
    description: PropTypes.string,
  }),
};

export default PostCardHighlight;
